import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import useIsomorphicLayoutEffect from '../helpers/useIsomorphicLayoutEffect';

let timeout;

const getOffsetTop = element => {
  if (!element) return 0;
  return getOffsetTop(element.offsetParent) + element.offsetTop;
};

const scrollToElement = element => {
  if (element) {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
    timeout = setTimeout(() => {
      const offset = getOffsetTop(element);
      if (window.pageYOffset !== offset) {
        element.focus();
        window.scrollTo(0, offset);
        scrollToElement(element);
      }
    }, 200);
  }
};

const Anchor = ({ location, children, className, id }) => {
  const { hash } = location;
  useIsomorphicLayoutEffect(() => {
    if (hash) {
      const hashId = hash.slice(1);
      if (hashId === id) {
        const element = document.getElementById(hashId);
        scrollToElement(element);
      }
    }
  }, [children, hash, id]);
  return (
    <>
      <div id={id} className={className} />
      {children}
    </>
  );
};

Anchor.propTypes = {
  location: PropTypes.shape({
    hash: PropTypes.string,
  }).isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string.isRequired,
};

Anchor.defaultProps = {
  className: '',
};

export default withRouter(Anchor);
